module.exports = __webpack_public_path__ + "img/duigong.de63000e.svg";